import ProgressArc from '../components/ProgressArc';
import TopBar from '../components/TopBar';
import { useStore } from '../store';

export default function ScenarioMenuScreen() {
  const s = useStore();
  const lesson = s.currentLesson;
  if (!lesson) return null;
  const progress = s.unitProgress(lesson);

  return (
    <div className="screen">
      <TopBar
        title={s.t('screen.scenario_menu.title')}
        subtitle={lesson.unit.trim()}
        onBack={s.backToUnitList}
        backLabel={s.t('nav.back')}
      />
      <div className="scroll">
        <div className="body">
          <div className="arc-holder">
            <ProgressArc progress={progress} size={180} width={14}>
              <span className="arc__pct">{Math.round(progress * 100)}%</span>
              <span className="arc__label">{s.t('scenario.progress_label')}</span>
            </ProgressArc>
          </div>

          <ModeCard
            icon="📖"
            title={s.t('mode.card_play.title')}
            desc={s.t('mode.card_play.desc')}
            onSelect={s.startCardPlay}
          />
          <ModeCard
            icon="✍️"
            title={s.t('mode.dictation.title')}
            desc={s.t('mode.dictation.desc')}
            onSelect={s.startDictation}
          />
          <ModeCard
            icon="📋"
            title={s.t('mode.expression_list.title')}
            desc={s.t('mode.expression_list.desc')}
            onSelect={s.startExpressionList}
          />
        </div>
      </div>
    </div>
  );
}

function ModeCard({
  icon,
  title,
  desc,
  onSelect,
}: {
  icon: string;
  title: string;
  desc: string;
  onSelect: () => void;
}) {
  return (
    <button type="button" className="mode-card" onClick={onSelect}>
      <span className="mode-card__badge" aria-hidden="true">
        {icon}
      </span>
      <span className="mode-card__text">
        <span className="mode-card__title">{title}</span>
        <span className="mode-card__desc">{desc}</span>
      </span>
    </button>
  );
}
